/* Meldet den React-Seiten, dass sich etwas im Editor geändert hat (Auswahl, Dokument, WADs, aktive Textur). Die Seiten lesen app dann neu. */
import { useSyncExternalStore } from 'react';

export interface Notifier { subscribe(fn: () => void): () => void; getVersion(): number; notify(): void }

export function createNotifier(): Notifier {
  let version = 0;
  const listeners = new Set<() => void>();
  return {
    subscribe: (fn) => { listeners.add(fn); return () => { listeners.delete(fn); }; },
    getVersion: () => version,
    notify: () => { version++; listeners.forEach((f) => f()); }
  };
}

export function useNotifier(n: Notifier): number {
  return useSyncExternalStore(n.subscribe, n.getVersion);
}
